import { styled } from '@mui/material';
import { CLASSES, BREADCRUMBS_CONSTANTS } from './constants/index.js';

const CommonWrapper = styled("li")({
    whiteSpace: "nowrap",
    display: "flex",
    textAlign: "center",
    alignItems: "center",
    [`&.${CLASSES.hidden}`]: {
        display: "none",
        "+ svg": {
            display: "none",
        },
    },
    [`&.${CLASSES.ellipsis}`]: {
        p: {
            display: "inline-block",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            width: BREADCRUMBS_CONSTANTS.LAST_CRUMB_ELLIPSIS_WIDTH,
        },
    },
});

export { CommonWrapper };
//# sourceMappingURL=CommonWrapper.js.map
